import React from "react";
import "./FilmCard.css";
import { generateRandomGradient } from "../NewsCard/News";

const FilmCard = ({ title, subtitle, description, image }) => {
  return (
    <div
      className="film-card"
      style={{
        fontFamily: "Montserrat, sans-serif",
      }}
    >
      {/* <div
      // className="film-image"
      // style={{
      //   backgroundImage: image ? `url(${image})` : generateRandomGradient(),
      // }}
      > */}
      <div
        className="film-title"
        style={{
          fontFamily: "Montserrat, sans-serif",
        }}
      >
        {title}
      </div>
      {/* </div> */}
      <div className="film-content">
        <h3 className="film-subtitle">{subtitle}</h3>
        <p className="film-description">{description}</p>
      </div>
    </div>
  );
};

export default FilmCard;
